/**
 * Conteúdo institucional padrão do manual reconstituído.
 * Estes textos não pertencem à máquina: valem para todo manual emitido
 * pela reconstituidora e por isso ficam fora do formulário editorial.
 */

export const TEXTOS = {
  introducao:
    'Este manual tem por finalidade fornecer as informações necessárias para a correta utilização, operação e manutenção do equipamento, visando assegurar a integridade física dos operadores, a confiabilidade operacional e o prolongamento da vida útil da máquina.',
  introducaoComplemento:
    'A leitura integral deste documento é obrigatória antes da instalação, da operação ou de qualquer intervenção de manutenção. O manual deve permanecer disponível, legível e acessível a todos os envolvidos durante toda a vida útil do equipamento.',

  sobreManual:
    'Este é um manual reconstituído. O equipamento não dispunha do manual original do fabricante e, para atender à legislação vigente, foi elaborado a partir do levantamento técnico realizado no local de instalação, da observação direta da máquina e das informações fornecidas pela contratante.',
  sobreManualLimite:
    'A reconstituição reproduz a condição encontrada na data do levantamento. Alterações, adequações ou modernizações realizadas após essa data não estão contempladas e exigem revisão deste documento.',

  materiaisIntro:
    'Para a reconstituição deste manual foram consultados os documentos, registros e fontes de informação listados a seguir:',

  simbologiaIntro:
    'Ao longo deste manual são utilizados os símbolos abaixo. Sempre que um deles aparecer, leia atentamente a informação associada antes de prosseguir.',

  publicoIntro:
    'Este manual destina-se aos profissionais relacionados a seguir, os quais devem ser capacitados, qualificados e formalmente autorizados pela contratante para as atividades que executam:',

  normasIntro:
    'A reconstituição deste manual observou a legislação e as normas técnicas aplicáveis relacionadas abaixo, nas edições vigentes na data do levantamento:',

  responsabilidades:
    'É de responsabilidade da contratante manter as condições de segurança do equipamento, garantir a capacitação e a autorização formal dos profissionais, preservar as proteções e os dispositivos de segurança instalados, executar o plano de manutenção previsto e manter este manual disponível no posto de trabalho.',
  responsabilidadesOperador:
    'É de responsabilidade do operador conhecer o conteúdo deste manual, utilizar os equipamentos de proteção individual definidos, comunicar imediatamente qualquer anomalia, interromper a operação diante de condição insegura e não neutralizar, remover ou alterar qualquer dispositivo de segurança.',

  garantia:
    'A reconstituição documental não constitui garantia de fabricação, de desempenho ou de conformidade construtiva do equipamento. A reconstituidora responde exclusivamente pelo conteúdo documental produzido a partir das informações disponíveis no levantamento.',
  garantiaIsencao:
    'Perde-se qualquer efeito deste documento em caso de modificação do equipamento, de uso diverso do previsto, de supressão de proteções ou de intervenção executada por profissional não autorizado.',

  seguranca:
    'A máquina somente pode ser utilizada em perfeitas condições técnicas, para a finalidade prevista, por profissional capacitado e consciente dos riscos, observando integralmente as instruções deste manual.',

  epcIntro:
    'Os equipamentos de proteção coletiva relacionados a seguir integram a máquina ou o posto de trabalho e não podem ser removidos, neutralizados ou alterados:',
  epiIntro:
    'O uso dos equipamentos de proteção individual listados abaixo é obrigatório na operação e nas intervenções sobre a máquina, conforme avaliação de risco da contratante:',
  treinamentoIntro:
    'Antes de operar ou intervir no equipamento, os profissionais devem possuir os treinamentos relacionados abaixo, com registro documental válido:',
  sinalizacaoIntro:
    'A sinalização de segurança aplicada ao equipamento deve permanecer íntegra e legível. Placas danificadas ou ilegíveis devem ser substituídas imediatamente.',
  energiaIntro:
    'As fontes de energia relacionadas a seguir alimentam o equipamento. Toda intervenção exige o bloqueio e a etiquetagem das fontes envolvidas, com verificação da ausência de energia residual.',
  conexaoEnergia:
    'A conexão às fontes de energia deve ser executada por profissional qualificado, com a máquina livre de pessoas e de ferramentas, após verificação das proteções e dos dispositivos de segurança.',
  desconexaoEnergia:
    'A desconexão deve seguir o procedimento de bloqueio e etiquetagem da contratante, com dissipação da energia residual e confirmação da ausência de tensão, pressão e movimento antes de qualquer intervenção.',
  funcoesIntro:
    'As funções de segurança relacionadas a seguir foram identificadas no equipamento. Elas devem ser verificadas periodicamente e jamais podem ser neutralizadas.',
  perigosIntro:
    'Os perigos identificados no equipamento estão relacionados a seguir. Perigos indissociáveis permanecem presentes mesmo com as proteções instaladas e exigem procedimento e capacitação; perigos dissociáveis são eliminados ou reduzidos pelas medidas de proteção indicadas.',
  emergenciaIntro:
    'Diante das situações de emergência relacionadas a seguir, acione o dispositivo de parada de emergência, isole a área e comunique imediatamente a liderança e a brigada de emergência da unidade.',

  /* Aberturas de capítulo — o manual-modelo abre todo capítulo dizendo o que
     ele cobre, e é isso que orienta o leitor que consulta só uma parte. */
  aberturaVisaoGeral:
    'Neste capítulo são apresentadas as características da máquina: a descrição funcional, as vistas com a identificação dos componentes e as especificações técnicas.',
  aberturaInstalacao:
    'Neste capítulo são apresentadas as recomendações gerais de transporte, armazenagem, montagem e instalação, içamento e elevação e ajustes originais de fábrica. O transporte, a montagem, a instalação e os ajustes devem ser acompanhados por profissional qualificado.',
  aberturaEncerramento:
    'Neste capítulo são apresentadas as orientações para a desativação, a desmontagem e o descarte da máquina ao final de sua vida útil.',
  aberturaGlossario:
    'Neste capítulo estão reunidos os termos técnicos e as abreviaturas utilizados neste manual, a fim de minimizar dúvidas na leitura do texto.',

  transporte:
    'O transporte deve ser executado por profissional habilitado, com equipamento de capacidade compatível com o peso da máquina, mantendo a carga estável e a área isolada durante a movimentação.',
  armazenagem:
    'Quando não estiver em uso, o equipamento deve permanecer em local coberto, seco, ventilado, protegido de intempéries e de impactos, com as superfícies usinadas preservadas contra corrosão.',
  icamento:
    'O içamento deve utilizar exclusivamente os pontos previstos para essa finalidade, com acessórios certificados e inspecionados. É proibida a permanência de pessoas sob a carga suspensa.',
  instalacao:
    'A instalação deve ser executada por profissional qualificado, com o equipamento nivelado, fixado e aterrado, respeitando os espaços de circulação, de manutenção e de acionamento dos dispositivos de emergência.',
  ajustes:
    'Os ajustes originais definidos no comissionamento não devem ser alterados sem análise técnica formal. Qualquer alteração exige nova avaliação de riscos e a revisão deste manual.',
  assistencia:
    'Intervenções corretivas, alterações de parâmetros e substituição de componentes de segurança devem ser executadas por profissional autorizado, com registro da atividade.',

  operacaoIntro:
    'A sequência descrita a seguir é obrigatória. Não inicie a operação sem concluir a preparação e sem confirmar que a área está livre de pessoas e de objetos estranhos ao processo.',
  emergenciaOperacao:
    'Em qualquer situação anormal, acione imediatamente o dispositivo de parada de emergência, bloqueie as fontes de energia e não restabeleça a operação antes da liberação formal da manutenção.',
  usoImprevisivelIntro:
    'Os usos razoavelmente previsíveis, porém indevidos, relacionados a seguir são expressamente proibidos:',

  manutencaoIntro:
    'Toda manutenção deve ser realizada com a máquina parada, com as fontes de energia bloqueadas e etiquetadas e com a energia residual dissipada, por profissional capacitado e autorizado.',
  limpezaIntro:
    'A limpeza deve ser executada com a máquina desenergizada, sem jato direto sobre painéis, sensores e componentes elétricos, e sem produtos que agridam vedações e superfícies.',
  falhasIntro:
    'A tabela a seguir relaciona as falhas mais frequentes, suas causas prováveis e as ações corretivas. Falhas não previstas devem ser tratadas pela manutenção.',

  desativacao:
    'A desativação deve ser precedida do bloqueio definitivo das fontes de energia, do esvaziamento de reservatórios e da sinalização do equipamento como fora de operação.',
  desmontagem:
    'A desmontagem deve seguir a ordem inversa da montagem, com apoio e escoramento das partes móveis e pesadas, por profissional capacitado.',
  descarte:
    'Resíduos, óleos, fluidos, componentes elétricos e eletrônicos devem ser destinados conforme a legislação ambiental vigente e o procedimento de resíduos da contratante.',

  avisoLegal:
    'Esta versão de manual se destina a apresentação para clientes e partes interessadas, não devendo ser reproduzido ou ter suas informações usadas indevidamente.',
} as const;

export interface AlertaModelo {
  tipo: 'proibido' | 'atencao' | 'obrigatorio' | 'informacao';
  titulo: string;
  texto: string;
}

export const SIMBOLOGIA: AlertaModelo[] = [
  {
    tipo: 'proibido',
    titulo: 'PROIBIDO',
    texto: 'Indica uma ação proibida cuja execução pode resultar em acidente grave, fatalidade ou dano ao equipamento.',
  },
  {
    tipo: 'atencao',
    titulo: 'ATENÇÃO',
    texto: 'Indica risco de lesão ou de dano ao equipamento caso a instrução associada não seja observada.',
  },
  {
    tipo: 'obrigatorio',
    titulo: 'AÇÃO OBRIGATÓRIA',
    texto: 'Indica procedimento, condição ou equipamento de proteção de cumprimento obrigatório.',
  },
  {
    tipo: 'informacao',
    titulo: 'INFORMAÇÃO',
    texto: 'Traz esclarecimento, recomendação ou boa prática relacionada à instrução apresentada.',
  },
];
